<template>
  <div id="content" class="dlnkcalendar_waitings container-fluid">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <div class="mb-7">
            <h1 class="display-4 text-white mb-4">Mes réservations</h1>
          </div>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
        </svg>
      </figure>
    </div>

    <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
      <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
        <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
      </svg>
    </figure>

    <div class="tab-content">

      <div class="container-fluid">
        <div class="row">
          <div class="col-4">
            <FullCalendar :key="calendar_key" ref="reservationCalendar" :options="calendar_options"/>
          </div>
          <div class="col-8">
            <div class="tab-pane active" id="reservations" role="tabpanel" aria-labelledby="books-tab">
              <!-- Pagination -->
              <div class="mt-2">
                <dlnkpagination
                    :page="reservations_page"
                    :page_count="reservations_page_count"
                    @next_page="next_reservation_page()"
                    @prev_page="prev_reservation_page()"
                    @set_page="set_reservation_page($event)">
                </dlnkpagination>
              </div>
              <!-- End Pagination -->

              <!-- Reservation list -->
              <div class="tab-wrapper">

                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Événement</th>
                    <th scope="col">Prénom</th>
                    <th scope="col">Nom</th>
                    <th scope="col">Téléphone</th>
<!--                    <th scope="col">Age</th>-->
                    <th scope="col">Date</th>
                    <th scope="col">Statut</th>
                    <th scope="col">Action</th>
                    <!--              <th scope="col">Rendez-vous</th>-->
                                  <th scope="col">Status</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="reservation in reservations" :key="reservations.id">
                    <th scope="row">
                      {{ reservation.id }}
                    </th>
                    <td>{{ reservation.event }}</td>
                    <td>{{ reservation.firstname }}</td>
                    <td>{{ reservation.lastname }}</td>
                    <td>{{ reservation.phone }}</td>
                    <td>{{ reservation.event_start }}</td>
                    <td>{{ reservation.reservation_status }}</td>
                    <td>
                      <button type="button"
                              v-if="reservation.status != 99"
                              data-tooltip="tooltip" title="Je me désinscris"
                              @click="delete_reservation(reservation.id)"
                              class="btn btn-sm btn-danger">
                        <span><i aria-hidden="true" class="fa fa-fw fa-trash"></i></span></button>
                    </td>
                    <!--              <td>{{ reservation.appointment_start_date }}</td>-->
                    <!--              <td>{{ reservation.reservation_status }}</td>-->
                  </tr>

                  </tbody>
                </table>

              </div>
              <!-- End Loans  -->

              <!-- Pagination -->
              <dlnkpagination
                  :page="reservations_page"
                  :page_count="reservations_page_count"
                  @next_page="next_reservation_page()"
                  @prev_page="prev_reservation_page()"
                  @set_page="set_reservation_page($event)">
              </dlnkpagination>
              <!-- End Pagination -->

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<script>

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import frLocale from '@fullcalendar/core/locales/fr';

export default {
  components: {
    FullCalendar // make the <FullCalendar> tag available
  },

  props: [
    'api_url',
    'customer_id',
  ],

  data: function () {
    const _this = this
    return {
      message: "",
      message_type: "",
      calendar_key: 0,
      calendar_options: {
        eventSources: [],
        editable: false,
        navLinks: true,
        locale: frLocale,
        eventDisplay: 'block',
        dayMaxEvents: 5,
        // headerToolbar: {center: 'dayGridMonth, timeGridDay'},
        plugins: [dayGridPlugin, timeGridPlugin],

        eventClick: function (info) {
          _this.eventClick(info)
        },
      },
      reservations_page: Number,
      reservations: Array(),
      reservations_count: Number,
      reservations_page_count: Number,
    }
  },

  mounted() {
    this.message = ""
    this.message_type = ""
    this.reservations_page = 1
    this.get_calendar()
  },

  watch: {
    reservations_page: function (new_val, old_val) {
      if (new_val < 1) {
        this.reservations_page = 1
      }
      if (new_val > this.reservations_page_count) {
        this.reservations_page = this.reservations_page_count
      }
      this.get_reservations()
    },
  },

  methods: {

    get_calendar: async function () {
      const _this = this
      const secure_key_1 = await get_token();
      const secure_key_2 = await get_token();
      const secure_key_3 = await get_token();
      const secure_key_4 = await get_token();
      let calendar = _this.$refs.reservationCalendar.getApi()

      calendar.addEventSource(
          {
            url: _this.api_url + '/resource_reservations.json?secure_key=' + secure_key_1 + '&customer_id=' + _this.customer_id,
            color: 'blue',
          }
      )
      calendar.addEventSource(
          {
            url: _this.api_url + '/event_reservations.json?secure_key=' + secure_key_2 + '&customer_id=' + _this.customer_id,
            color: 'green',
          }
      )
      calendar.addEventSource(
          {
            url: _this.api_url + '/pre_registrations.json?secure_key=' + secure_key_3 + '&customer_id=' + _this.customer_id,
            color: 'purple',
          }
      )
      calendar.addEventSource(
          {
            url: _this.api_url + '/event_reservations/appointments.json?secure_key=' + secure_key_4 + '&customer_id=' + _this.customer_id,
            color: 'purple',
          }
      )

    },

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    get_data: function () {
      // this.get_waitings()
      this.get_reservations()
    },

    delete_reservation: async function(event_id) {
      const _this = this

      if (confirm('Êtes vous certain de vouloir supprimer votre réservation')) {
        const secure_key = await get_token();
        const url = _this.api_url + '/event_reservations/' + event_id + '.json?secure_key=' + secure_key + '&customer_id=' + _this.customer_id
        axios.delete(url)
        .then(function (response) {
        _this.get_data()
        })
      }
    },

    get_reservations: function () {
      const _this = this
      const url = '/modules/dlnkcalendar/actions/my_reservations.php?page=' + _this.reservations_page
      axios.get(url)
          .then(function (response) {
            _this.reservations = response.data.reservations
            _this.reservations_count = response.data.reservations_count
            _this.reservations_page_count = response.data.pages_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    set_reservation_page: function (page) {
      page = parseInt(page)
      this.reservations_page = page
    },

    next_reservation_page: function () {
      this.reservations_page++
    },

    prev_reservation_page: function () {
      this.reservations_page--
    },

    eventClick: function (info) {
      alert(info.event.title)
    }
  }
}

</script>
